// Contexts
import { getConfigProperty } from "../../EnvironmentConfig/EnvironmentConfig";
// Types
import { OrganizationCodeTypes, OrganizationDetailsEnvSpecific } from "../../types/OrganizationTypes";
// Constants
import {
  BASIC_AUTH_TOKEN_CD,
  BASIC_AUTH_TOKEN_TORFX,
  BASIC_AUTH_TOKEN_TORFXOZ,
  BASIC_AUTH_TOKEN_FCG,
  BASIC_AUTH_TOKEN_CDSA
} from "../Constants/Constants";

export const getBasicAuthToken = (referringCompany, authByOcta = false) => {
  let BasicAuthToken;

  const BASIC_AUTH_TOKEN_SELECTOR = {
    currenciesdirect:BASIC_AUTH_TOKEN_CD,
    currenciesdirectsa:BASIC_AUTH_TOKEN_CDSA,
    torfx:BASIC_AUTH_TOKEN_TORFX,
    torfxoz:BASIC_AUTH_TOKEN_TORFXOZ,
    fcg:BASIC_AUTH_TOKEN_FCG,
  };

  const basicAuthTokenKey: string = authByOcta ? 'octaBasicAuthToken' : 'basicAuthToken';

  BasicAuthToken = (getConfigProperty(basicAuthTokenKey) as OrganizationDetailsEnvSpecific)[referringCompany as OrganizationCodeTypes] || BASIC_AUTH_TOKEN_SELECTOR[referringCompany];

  return BasicAuthToken;
};
